module.exports = __webpack_public_path__ + "static/media/info-red.900b7232.svg";